import { useAuth } from '@/logic/state';

import shallow from 'zustand/shallow';
import { useGetBalance } from '@/features/wallet/services/_api';
import { CASHBACK } from '../services/types';

// This custom hook is used to call get cashback balance api

export const useCashbackBalance = () => {
  const [user, setUser] = useAuth(s => [s.user, s.setUser], shallow);

  const {
    isFetching: isFetchingBalance,
    isSuccess: isSuccessBalance,
    isError: isErrorBalance,
    refetch: refetchBalance,
  } = useGetBalance(
    {
      params: {
        walletType: CASHBACK,
      },
    },
    {
      enabled: Boolean(user?.token),
      onSuccess: ({ balance, transaction }) => {
        setUser(prevState => ({
          ...prevState,
          cashbackBalance: balance ?? 0,
          cashbackTransaction: transaction ?? null,
        }));
      },
    }
  );

  // useGetDetailedBalanceQuery(
  //   {},
  //   {
  //     enabled: Boolean(user?.isCompleteProfile && user?.isVerified),
  //     onSuccess: ({ cashbackWalletBalance, eWalletBalance, totalBalance }) => {
  //       setUser(prevState => ({
  //         ...prevState,
  //         walletDetailedBalance: eWalletBalance,
  //         cashbackDetailedBalance: cashbackWalletBalance,
  //         totalDetailedBalance: totalBalance,
  //       }));
  //     },
  //   }
  // );

  return {
    isFetchingBalance,
    isSuccessBalance,
    isErrorBalance,
    refetchBalance,
  };
};
